import MainLayout from '../../../../commons/layout/MainLayout';
import VideoComponentCustom from '../../../../commons/components/Video';
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import HeaderHs2 from '../../../../commons/components/Header/headerHs2';
import { useEffect, useState } from 'react';
import PopComponent from '../../../../commons/components/Popup/PopupComponent';
import ThumnailVideoComponent from '../../../../commons/components/Video/thumbnailVideo';
import ButtonComponent from '../../../../commons/components/Forms/ButtonComponent';
import TextInputComponent from '../../../../commons/components/Forms/TextInputComponent';
import VideoFormStatusComponent from './videoFormStatus';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import SkeletonLoadingComponent from '../../../../commons/components/SkeletonLoading';
import { convertUrlTObject, sharekakaoApi, shareKakaoTalk } from '../../../../utils/helpers';
import DialogConfirmDelComponent from '../detail/dialogConfirmDelVideo';
import ROUTERS from '../../../../commons/constans/router';
import DialogComponent from '../../../../commons/components/Modal/DialogComponent';
import API, { ROUTES } from '../../../../commons/api/api';
import {
  updateSuccess,
  updateUserRequest,
} from '../../../Account/redux/actions';
import DialogPublishSuccess from './dialogPublishSuccess';
import TextareaComponent from '../../../../commons/components/Forms/TextareaComponent';

type Props = {
  footerShow: Boolean,
  videoDetail: Object,
  updateVideo: Function,
  videoEmoji: Array,
  isProcessing: Boolean,
  isProcessingEmoji: Boolean,
  deleteVideo: Function,
  isProcessingTitle: Boolean,
  isProcessingDel: Boolean,
};
const VideoDetailComponent = ({
  videoDetail,
  updateVideo,
  videoEmoji,
  isProcessing,
  isProcessingEmoji,
  deleteVideo,
  isProcessingTitle,
  isProcessingDel,
}: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const param = useParams();
  const [showPublic, setShowPublic] = useState(false);
  const [statusUpdateTitle, setStatusUpdateTitle] = useState(false);
  const [statusDelete, setStatusDelete] = useState(false);
  const [popupDeletedVideo, setPopupDeleteVideo] = useState(false);
  const [showFooter, setShowFooter] = useState(true);
  const { userInfo } = useSelector((state) => state.authReducers);
  const [popupHeight, setPopupHeight] = useState('68vh');
  const [statusDialogUpdateSuccess, setStatusDialogUpdateSuccess] = useState(false);
  const [isShowTemplate, setIsShowTemplate] = useState(false);
  const [dataVideoUpdate, setDataVideoUpdate] = useState({
    id: videoDetail?.video_message?.id || null,
    title: videoDetail?.video_message?.title || '',
    reaction_emoji: videoDetail?.video_message?.reaction_emoji || '',
    reaction_content: videoDetail?.video_message?.reaction_content || '',
    published_at: videoDetail?.video_message?.published_at || '',
    user_published_at: videoDetail?.video_message?.user_published_at || '',
  });
  useEffect(() => {
    let host = `${process.env.REACT_APP_URL}${location.pathname}`;
    // console.log(host, 'location');
    scrollTo(0, 0);
  }, []);

  window.callSendShareUrl = function (url) {
    let urlWeb = `${process.env.REACT_APP_URL}${location.pathname}?kakaolink`;
    if (urlWeb !== url) {
      navigate(url);
    }
  };

  useEffect(() => {
    if (!isProcessingDel) {
      if (isProcessing === false && !videoDetail?.video_message?.id) {
        if (location && location.search === '?kakaolink') {
          setPopupDeleteVideo(true);
        }
      } else {
        setDataVideoUpdate({
          id: videoDetail?.video_message?.id || null,
          title: videoDetail?.video_message?.title || '',
          reaction_emoji: videoDetail?.video_message?.reaction_emoji || '',
          reaction_content: videoDetail?.video_message?.reaction_content || '',
          published_at: videoDetail?.video_message?.published_at || '',
          user_published_at: videoDetail?.video_message?.user_published_at || '',
        });

        if (
          videoDetail.video_message?.completed_checked_status &&
          videoDetail.video_message?.completed_checked_status == 'view'
        ) {
          let completedCheckedStatus = {
            id: videoDetail?.video_message?.id || null,
            title: videoDetail?.video_message?.title || '',
            reaction_emoji: videoDetail?.video_message?.reaction_emoji || '',
            reaction_content:
              videoDetail?.video_message?.reaction_content || '',
            published_at: videoDetail?.video_message?.published_at || '',
            user_published_at: videoDetail?.video_message?.user_published_at || '',
            completed_checked_status: 'viewed',
          };

          dispatch(updateVideo(completedCheckedStatus));

          let badgeCount = userInfo.album_badge_count - 1;

          //update badge in user
          var formData = new FormData();
          formData.append('album_badge_count', badgeCount);
          if (badgeCount >= 0) {
            dispatch(updateUserRequest(formData));
          }
        }
      }
    }
  }, [videoDetail, isProcessing, isProcessingDel]);

  const handleLeftClick = () => {
    if (location.state != null && location.state === 'backFromVideoPlayer') {
      navigate(ROUTERS.ALBUM);
    } else {
      if (location && location.search === '?kakaolink') {
        navigate(ROUTERS.HOME);
      } else if (location.state?.prevPath) {
        navigate(-1);
      } else {
        navigate(ROUTERS.HOME);
      }
    }
  };

  const handleShowPublic = () => {
    setShowPublic(true);
  };

  const _handleCloseModal = () => {
    setShowPublic(false);
  };

  const handleChangeIpt = (e) => {
    let trimContent = e.target.value.trim();
    setStatusUpdateTitle(trimContent != '' ? false : true);
    setDataVideoUpdate({
      ...dataVideoUpdate,
      title: trimContent != '' ? e.target.value : '',
    });
  };

  const handleClickBtn = () => {
    setStatusUpdateTitle(true);
  };

  const handleDeleteVideo = () => {
    if (userInfo.id !== videoDetail.user_id) return false;
    setStatusDelete(true);
  };

  const callDeleteVideo = () => {
    window.nativeVideoFullScreenIos(false);
    let data = {
      id: videoDetail.video_message.id,
    };
    dispatch(deleteVideo(data));

    if (location && location.search === '?kakaolink') {
      navigate(ROUTERS.ALBUM);
    } else {
      console.log(location, 'location callDeleteVideo');
      navigate(-1);
    }
  };

  const handleClose = () => {
    setStatusDelete(false);
  };

  const handleShareKakao = () => {
    if (userInfo.id !== videoDetail.user_id) return false;

    //share video share-kakao 
    let data = {
      obj_id: videoDetail?.video_message?.id || '',
      obj_type: 'VIDEO_MESSAGE',
      channel: 'KAKAO'
    }
    sharekakaoApi(data);
    let pathName = `video/detail/${videoDetail.id}`;
    let linkRedirect = `${process.env.REACT_APP_URL}/video/detail/${videoDetail.id}`;
    shareKakaoTalk(
      'Sphokidz',
      '캐릭터 천국, 스포키즈 영상메시지를 공유합니다',
      videoDetail?.video_url || '',
      videoDetail?.photo_url || '',
      pathName,
      linkRedirect
    );
  };

  const closePopupStatus = () => {
    setShowPublic(false);
  };

  const handleForcusIpt = () => {
    setShowFooter(false);
  };

  const handleBlurIpt = () => {
    setShowFooter(true);
  };

  const handleClosePopupNotiDeleted = () => {
    setPopupDeleteVideo(false);
    navigate(ROUTERS.HOME);
  };

  const handleHeightPopup = (height) => {
    // console.log(height, 'setHeightPopup');
    setPopupHeight(height);
  };

  const handleDialogConfirmUpdateStatus = (data) => {
    setShowPublic(false);
    setStatusDialogUpdateSuccess(true);
  };

  const handleCloseUpdate = () => {
    setStatusDialogUpdateSuccess(false);
    //
    console.log('handleCloseUpdate');
    navigate(ROUTERS.ALBUM);
  };

  const handleViewTemplate = () => {
    setIsShowTemplate(true);
  };

  const handleDownload = () => {
    // let data = convertUrlTObject(videoDetail?.video_url || '');
    console.log('handleDownload', videoDetail?.video_url || '');
    window.nativeDownloadvideo(videoDetail?.video_url || '');
  };

  const handleCloseTemplate = () => {
    setIsShowTemplate(false);
  }

  const converHtmlToDiv = (data) => {
    console.log(261, data);
    if (!data) return '';
    let arr = data.split('\n');
    let arrDiv = [];
    if (arr.length > 0 && arr[0] != '') {
      arr.map((item, idx) => {
        let html = `<div>${item}</div>`
        arrDiv.push(html);
      })
      if (arr.length < 10) {
        for (let index = 0; index < 10; index++) {
          arrDiv.push(`<div> </div>`);
        }
      }
    }else{
      for (let index = 0; index < 20; index++) {
        arrDiv.push(`<div> </div>`);
      }
    }
    return arrDiv.join('');
  }


  return (
    <MainLayout
      pageID={'album-video-detail-page'}
      displayBottomNav={false}
      activeNav={`VIDEO`}
    >
      <HeaderHs2
        labelRight={false}
        labelLeft={true}
        title="영상 정보"
        handleLabelLeft={() => handleLeftClick()}
      />
      <div className="wrapper">
        <div className="album-video-detail-page__video-detail">
          <ThumnailVideoComponent
            userInfo={userInfo}
            location={location}
            videoDetail={videoDetail}
            isProcessing={statusUpdateTitle ? false : isProcessing}
            player={true}
          />
          <div className="row">
            <div className="col-12 ml-2 mt-1 pr-4">
              <div className="d-flex justify-content-between">
                <div className="video-title">
                  <p className="album-video-detail-page__video-detail-title">
                    {videoDetail?.video_message?.title || (
                      <SkeletonLoadingComponent width={250} height={20} />
                    )}
                  </p>
                </div>
                {userInfo.id === videoDetail.user_id && (
                  <div className="share-kakao">
                    <img
                      src="/images/album/icon_view_template.svg"
                      alt=""
                      onClick={() => handleViewTemplate()}
                    />
                    <img
                      src="/images/album/icon_download_video.svg"
                      alt=""
                      onClick={() => handleDownload()}
                    />
                    <img
                      src="/images/album/icon_kakao_black.svg"
                      alt=""
                      onClick={() => handleShareKakao()}
                    />
                    <img
                      src="/images/album/icon_delete_black.svg"
                      alt=""
                      onClick={() => handleDeleteVideo()}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="album-video-detail-page__content">
          <div className="input-component">
            <div className="input-group album-video-detail-page__input-group">
              <div className="album-video-detail-page__custom-input">
                <TextInputComponent
                  value={dataVideoUpdate?.title || ''}
                  type={`text`}
                  label={`제목`}
                  name={`title`}
                  errorMsg={
                    isProcessing === false
                      ? dataVideoUpdate?.title
                        ? ''
                        : '영상 제목 입력해주세요'
                      : ''
                  }
                  isRequired={dataVideoUpdate?.title !== '' ? false : true}
                  handleChange={handleChangeIpt}
                  handleFocus={handleForcusIpt}
                  handleBlur={handleBlurIpt}
                  maxLength={190}
                  disabled={userInfo.id !== videoDetail.user_id}
                />
              </div>
              <div
                className="btn-update-title-video"
                style={{
                  marginTop:
                    isProcessing === false
                      ? dataVideoUpdate?.title == ''
                        ? '0px'
                        : '20px'
                      : '20px',
                }}
              >
                <ButtonComponent
                  label={`수정`}
                  cssClass={`btn album-video-detail-page__button-custom`}
                  handleClick={handleClickBtn}
                  disabled={
                    dataVideoUpdate?.title == ''
                      ? true
                      : false ||
                        isProcessingTitle ||
                        userInfo.id !== videoDetail.user_id
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className="album-video-detail-page__public">
          <div className="album-video-detail-page__public__status">
            <label className="label">영상 공개하기</label>
          </div>
          {(videoDetail?.video_message?.user_published_at === null && videoDetail?.video_message?.published_at === null) ||
          (videoDetail?.video_message?.user_published_at === '' && videoDetail?.video_message?.published_at === '') ? (
            <div className="col-12 album-video-detail-page__content">
              <p className="text-center p-0 m-0">영상을 공개하고</p>
              <p className="text-center p-0 m-0">푸짐한 상품을 받아가세요!</p>
            </div>
          ) : (
            !showPublic && (
              <VideoFormStatusComponent
                videoDetail={videoDetail}
                videoEmoji={videoEmoji}
                showPublic={showPublic}
                isProcessingEmoji={isProcessingEmoji}
              />
            )
          )}
        </div>
        {(videoDetail?.video_message?.user_published_at === null && videoDetail?.video_message?.published_at === null) ||
          (videoDetail?.video_message?.user_published_at === '' && videoDetail?.video_message?.published_at === '') ? (
          <div className="row album-video-detail-page__button-publish">
            <div className="col-12 text-center">
              <button
                type="button"
                className="btn col-12 btn-rounded btn-block btn-primary"
                onClick={() => handleShowPublic()}
                disabled={userInfo.id !== videoDetail.user_id}
              >
                영상 공개하기{' '}
                <img
                  className="mb-1 ml-2"
                  src="/images/album/icon_next_btn_w.svg"
                  alt=""
                />
              </button>
            </div>
          </div>
        ) : (
          <>
            <div className="mb-5">
              <br />
            </div>
          </>
        )}
      </div>
      {showPublic && (
        <PopComponent
          id={'js-popup-publish'}
          show={showPublic}
          handleClose={_handleCloseModal}
          bodyStyle={{ height: popupHeight }}
          headingStyle={{ marginTop: '20px' }}
          title={'공개하기'}
        >
          <div className="modal-public">
            <div className="modal-public__content">
              <p className="text-center p-0 m-0">아이들의 반응은 어땠나요?</p>
              <p className="text-center p-0 m-0">
                간단한 이용 후기와 함께 영상을 공개하면
              </p>
              <p className="text-center p-0 m-0">
                추첨을 통해 선물을 드립니다.
              </p>
            </div>
            <div className="modal-public__status mt-1">
              <VideoFormStatusComponent
                videoDetail={videoDetail}
                isProcessing={isProcessing}
                closePopupStatus={closePopupStatus}
                publishedBtn={videoDetail?.video_message?.published_at ? false : true}
                videoEmoji={videoEmoji}
                handleHeightPopup={handleHeightPopup}
                handleDialogConfirmUpdateStatus={
                  handleDialogConfirmUpdateStatus
                }
              />
            </div>
          </div>
        </PopComponent>
      )}

      <DialogConfirmDelComponent
        statusDelete={statusDelete}
        handleClose={handleClose}
        callDeleteVideo={callDeleteVideo}
        className={`dialog-custom-button`}
      />

      <DialogComponent
        id={``}
        children={``}
        show={popupDeletedVideo}
        title={`알림`}
        closeBtn={`확인`}
        handleClose={handleClosePopupNotiDeleted}
      >
        <div className="content-dialog">
          제작자가 영상을 삭제하였음으로 해당 영상을 볼 수 없습니다.
        </div>
      </DialogComponent>

      <DialogPublishSuccess
        statusDialogUpdateSuccess={statusDialogUpdateSuccess}
        handleCloseUpdate={handleCloseUpdate}
      />

      <DialogComponent
        id={`js-template-view `}
        children={``}
        show={isShowTemplate}
        displayClose={true}
        title={`편지 내용`}
        closeBtn={`닫기`}
        handleClose={handleCloseTemplate}
        className={`popup-template-step2`} // ${isShowValidate.isShow ? 'disabled-popup' : ''}
      >
        <div className="content-template">
          <div className="text">
          </div>
          <div className="img">
            <img src="/images/templateOld.png" alt="" />
          </div>

          <div className="content-dialog">
            {/* <div className={`text-area`} id="backdrop">
              <div
                className="highlights"
                dangerouslySetInnerHTML={{ __html: videoDetail.video_message?.content || '' }}
              ></div>
            </div>
            <TextareaComponent
              label={false}
              placeHolder={''}
              id={'js-add-template'}
              name={'content'}
              value={videoDetail.video_message?.content || ''}
              rows={10}
              readonly={true}
            /> */}

              <div 
                className='content-template-popup' 
                dangerouslySetInnerHTML={{__html: converHtmlToDiv(videoDetail.video_message?.content || '') }}
              >
            </div>
          </div>
        </div>
      </DialogComponent>
    </MainLayout>
  );
};

export default VideoDetailComponent;
